import React from "react";

export const Ports = [
  <div className="slideContainer slideContainerVideo">
    <h4 className="slideTitle">
      Hallo Holland Hydrogen 1 | Europe’s largest hydrogen plant
    </h4>
    <div class="video_container">
      <video width="320" height="240" controls poster="videos/port-success-stories-holland-hydrogen.jpg">
        <source
          src="videos/Hallo Holland Hydrogen 1 Europe’s largest hydrogen plant.mp4"
          type="video/mp4"
        />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
      <img src="images/qr/qr-ports-success-story-video-02.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
  <div className="slideContainer slide_TextImageRight">
    <h4 className="slideTitle">De LNG London</h4>
    <div className="slideText">
      <p>
        Nederland heeft de grootste binnenvaartvloot van West-Europa. De sector
        zoekt mogelijkheden om minder broeikasgassen uit te stoten en te voldoen
        aan steeds scherpere milieueisen. Het gebruik van vloeibaar aardgas LNG
        (liquid natural gas) is daarvoor een geschikte mogelijkheid.
      </p>
      <p>
        In de zomer van 2019 is het LNG-bunkerschip voor de binnenvaart in
        gebruik genomen: de LNG London. Het schip kan eventueel ook
        containerschepen voor zowel de zee- als binnenvaart en onshore-terminals
        van LNG voorzien, maar richt zich in eerste instantie op
        binnenvaartschepen in het ARA-gebied (Amsterdam-Rotterdam—Antwerpen).
      </p>
      <p>
        Hiermee steunt Shell Nederland de verduurzaming van de binnenvaart. De
        LNG London (eigendom van LNG Shipping – een samenwerking tussen Victrol
        en Sogestran) is voor de lange termijn gecharterd door Shell. Het schip
        zal LNG afnemen van de Gate-terminal in Rotterdam. Shell Nederland heeft
        inmiddels drie LNG-bunkerschepen in de vaart.
      </p>
    </div>
    <div className="slideImage">
      <img
        src="images/8572d87e-aade-470c-a500-cdb1098450d8-cropped.jpg"
        alt=""
        width="560"
        height="auto"
      />
    </div>
  </div>,
  <div className="slideContainer slideContainerVideo">
    <h4 className="slideTitle">DSCG & Maersk project</h4>
    <div class="video_container">
      <video width="320" height="240" controls>
        <source src="videos/DSCG & Maersk project.mp4" type="video/mp4" />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
      <img src="images/qr/qr-ports-success-story-video-05.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
  <div className="slideContainer slide_TextImageRight">
    <h4 className="slideTitle">H-vision</h4>
    <div className="slideText">
      <p>
        De industrie in de Rotterdamse haven verbruikt veel energie en stoot als
        gevolg daarvan veel CO₂ uit. Verduurzaming is dus noodzakelijk, maar hoe
        doe je dat? Het grootschalige gebruik van waterstof als energiedrager
        zou een oplossing kunnen zijn.
      </p>
      <p>
        H-vision verkent de haalbaarheid van deze optie. Invoering biedt
        Rotterdam de mogelijkheid om nog vóór 2030 de CO₂-uitstoot aanzienlijk
        te verlagen. Onder leiding van de Rotterdamse
        haven-ondernemersvereniging Deltalinqs werkt Shell Nederland samen met
        15 partijen: TNO, Air Liquide, BP, EBN, Engie, Equinor, Gasunie,
        GasTerra, OCI, Havenbedrijf Rotterdam, TAQA, Uniper, Koninklijke Vopak
        en Linde. Deze bedrijven vertegenwoordigen de waterstofketen van
        productie tot gebruik. H-vision richt zich op de productie van het
        zogeheten blauwe waterstof, dat wordt gemaakt op basis van aardgas en
        restgassen uit de industrie. Bij deze productie komt CO₂ vrij, dat
        veilig kan worden opgeslagen in lege gasvelden onder de Noordzee of
        wordt hergebruikt als groeiversneller in kassen in de regio.
      </p>
      <p>
        Door de realisering van H-vision kan er op de langere termijn
        makkelijker groene waterstof worden gebruikt vanwege de kennis en kunde
        die is opgedaan, omdat de infrastructuur al is aangelegd en omdat
        eindgebruikers al van gas naar waterstof zijn omgeschakeld.
      </p>
    </div>
    <div className="slideImage">
      <img
        src="images/8572d87e-aade-470c-a500-cdb1098450d8-cropped.jpg"
        alt=""
        width="560"
        height="auto"
      />
    </div>
  </div>,
  <>
    <div className="slideContainer slide_solidColour">
      <div className="colLeft col50">
        <h4 className="slideTitle">Het LNG-bunkerschip de Cardissa</h4>
        <p>
          De internationale scheepvaart moet minder broeikasgassen gaan
          uitstoten. Daarom is vloeibaar aardgas (Liquid Natural Gas, of “LNG”)
          bezig aan een opgang in de maritieme sector.
        </p>
        <p>
          In 2017 werd de Cardissa in gebruik genomen, Shells hypermoderne
          LNG-bunkerschip, om te kunnen voldoen aan de toenemende vraag. Met de
          Cardissa kan Shell de scheepvaart van LNG voorzien. LNG zorgt voor een
          lagere uitstoot van bijvoorbeeld zwavel en fijnstof en biedt een
          significante reductie in stikstofoxiden.
        </p>
        <p>
          Het op de STX-scheepswerf in Zuid-Korea gebouwde schip is een van de
          grootste LNG-bunkerschepen ter wereld. De Cardissa kan 1.000 m³ LNG
          per uur overslaan, wat vergelijkbaar is met conventionele
          bunkerschepen die schepen voorzien van stookolie en diesel. Het schip
          heeft een laadcapaciteit van 6.500 m³ LNG. Dit lijkt misschien minder
          dan het is. LNG bedraagt echter slechts een zeshonderdste van het
          volume van ‘gewoon’ aardgas, omdat het gecomprimeerd is op een
          temperatuur van -162 graden Celsius.
        </p>
        <p>
          Vanuit Rotterdam kan de Cardissa langs de Noordzee en de Baltische
          kust allerlei soorten schepen, van kleine kustvaarders tot grote
          trans-Atlantische schepen, bevoorraden. Het schip heeft een hoge
          wendbaarheid waardoor het veilig en efficiënt kan tanken – bunkeren in
          scheepvaarttermen.
        </p>
      </div>
      <div className="colRight col50 solidColourContainer stats align-self-start">
        <div class="d-flex">
          <p className="figureContainer">
            <span className="figure">1000</span>
            <br />m<sup>3</sup> LNG/uur overslaan
          </p>
        </div>
      </div>
    </div>
  </>,
];
